import List from '@/pages/admin/complianceDocuments/List.vue';
import Show from '@/pages/admin/complianceDocuments/Show.vue';
import handleActivePaginationRouteProps from '@/utils/handleActivePaginationRouteProps.js';

export default [
  {
    path: 'compliance_documents',
    name: 'compliance-documents',
    component: List,
    props: handleActivePaginationRouteProps,
  },
  {
    path: 'compliance_documents/:id(\\d+)',
    name: 'compliance-document',
    component: Show,
  },
];
